import React from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import Icon from 'react-fa';
import { LinkContainer } from 'react-router-bootstrap';
import AdminStore from '../../stores/AdminStore';
import UserTableContainer from './UserTableContainer.react';

const ResetOption = () => (
  <Row>
    <Col xs={3}>
      <LinkContainer to='/admin/password'>
        <Button bsStyle='primary' ><Icon name='gear' /> Reset Password</Button>
      </LinkContainer>
    </Col>
    <Col xs={8} />
  </Row>
);

function getAdminState() {
  return {
    options: AdminStore.getState(),
    showError: !AdminStore.hasAdminOptions(),
  };
}

export default class AdminOptions extends React.Component {
  constructor(props) {
    super(props);
    this.state = getAdminState();
    this._onChange = this._onChange.bind(this);
  }


  componentDidMount() {
    this.adminSubscription = AdminStore.addListener(this._onChange);
  }

  componentWillUnmount() {
    this.adminSubscription.remove();
  }

  _onChange() {
    this.setState(getAdminState());
  }

  render() {
    return (
      <div className='adminBody'>
        {this.state.showError &&
          <p>There are no administration options available to you at this time.</p>}
        {this.state.options.canResetPassword && <ResetOption />}
        {this.state.options.canAdministerUsers && <UserTableContainer />}
      </div>
    );
  }
}
